import { createFeatureSelector, createSelector } from "@ngrx/store";
import { navigationActionFeatureKey, NavigationActionState } from "./navigation-action.reducer";

export const currentNavigationActionState = createFeatureSelector<NavigationActionState>(navigationActionFeatureKey);

export const currentNavigationAction = createSelector(
    currentNavigationActionState,
    (state: NavigationActionState) => state.navigationAction
);